// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2C1t-","spin":"Loader_spin__s8ZHN"};